import {
    FILTER_INVOICES,
    INVOICE_DETAIL_REQUEST_FAILED,
    INVOICE_DETAIL_REQUEST_STARTED,
    INVOICE_DETAIL_REQUEST_SUCCESS,
    INVOICE_LIST_CLOSE_NOTIFICATION, INVOICE_LIST_FORM_VALUE_CHANGED,
    INVOICE_LIST_REQUEST_FAILED,
    INVOICE_LIST_REQUEST_STARTED,
    INVOICE_LIST_REQUEST_SUCCESS,
    INVOICE_SETTING_REQUEST_FAILED,
    INVOICE_SETTING_REQUEST_STARTED,
    INVOICE_SETTING_REQUEST_SUCCESS
} from "./InvoiceListConstants";

let today = new Date();

const initialState = {
    invoices: [],
    filteredInvoices: [],
    isLoading: false,
    customers: [],
    searchError: false,
    notification: {},
    invoiceDetail: {
        loading: false,
        lines: []
    },
    setting: {},
    formValues: {
        startDate: new Date()
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case INVOICE_SETTING_REQUEST_STARTED:
            return {
                ...state,
                isLoading: true
            }
        case INVOICE_SETTING_REQUEST_SUCCESS:
            return {
                ...state,
                setting: action.payload,
                formValues: {
                    startDate: action.payload.startDate
                }
            }

        case INVOICE_SETTING_REQUEST_FAILED:
            return {
                ...state,
                isLoading: false,
                notification: {
                    show: true,
                    type: 'error',
                    message: action.payload
                }
            }

        case INVOICE_LIST_REQUEST_STARTED:
            return {
                ...state,
                isLoading: true
            }
        case INVOICE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                invoices: action.payload,
                filteredInvoices: action.payload,
                notification: {
                    ...state.notification,
                    show: false,
                }
            }

        case INVOICE_LIST_REQUEST_FAILED:
            return {
                ...state,
                isLoading: false,
                invoices: [],
                filteredInvoices: [],
                notification: {
                    show: true,
                    type: 'error',
                    message: action.payload
                }
            }
        case FILTER_INVOICES:
            if (!state || !state.invoices) {
                return state;
            }
            let searchKey = action.payload;
            if (!searchKey) {
                return {
                    ...state,
                    filteredInvoices: state.invoices
                }
            }
            const searchedInvoices = state.invoices.filter(invoice => {
                return invoice.invoiceNumber.fuzzySearch(searchKey) ||
                    invoice.customerName.fuzzySearch(searchKey) ||
                    invoice.formattedInvoiceDate.fuzzySearch(searchKey) ||
                    invoice.deliveryName.fuzzySearch(searchKey) ||
                    (invoice.formattedNett && invoice.formattedNett.fuzzySearch(searchKey)) ||
                    (invoice.detailLines && invoice.detailLines.toString().fuzzySearch(searchKey))
            })
            return {
                ...state,
                filteredInvoices: searchedInvoices
            }
        case INVOICE_LIST_CLOSE_NOTIFICATION:
            return {
                ...state,
                notification: {
                    show: false,
                    type: '',
                    message: ''
                }
            }


        case INVOICE_DETAIL_REQUEST_STARTED:
            return {
                ...state,
                detailLine: {
                    loading: true
                }
            }
        case INVOICE_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                invoiceDetail: {
                    loading: false,
                    lines: action.payload
                }
            }

        case INVOICE_DETAIL_REQUEST_FAILED:
            return {
                ...state,
                invoiceDetail: {
                    loading: false,
                    lines: []
                },
                notification: {
                    show: true,
                    type: 'error',
                    message: action.payload
                }
            }
        case INVOICE_LIST_FORM_VALUE_CHANGED: {
            return {
                ...state,
                formValues: {
                    [action.payload.name]: action.payload.value
                }
            }
        }
        default:
            return state

    }
}
String.prototype.fuzzySearch = function (searchKey) {
    let hay = this.toLowerCase(),
        i = 0,
        n = -1,
        l;
    searchKey = searchKey.toLowerCase();

    for (; l = searchKey[i++];) {
        if (!~(n = hay.indexOf(l, n + 1))) return false;
    }

    return true;
};
export default reducer;
